import type { NotifiableError } from '@bugsnag/js'
import Bugsnag from '~/services/bugsnag'

export function notifyError (error: NotifiableError) {
  Bugsnag.notify(error)
  console.error(error)
}
